import typeToReducer from 'type-to-reducer'

import matchVideoFacade from '../facades/matchVideo'

export default typeToReducer({}, matchVideoFacade().get())
